// simple animation that fades the entire
// elm in then subsequently animates any item that
// have data-animate attr

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { CSSPlugin } from 'gsap/all'
const lib = require('../library')

// data-animate-heading
// data-animate-view-all
// data-animate-callout
// data-animate-event
// data-animate-more-links

gsap.registerPlugin(ScrollTrigger, CSSPlugin)

export default class AnimationWebinars {
  constructor(el) {
    this.el = el
    this.setVars()
    if (this.events.length > 0) {
      this.init()
    }
  }

  setVars() {
    this.heading = this.el.querySelector('[data-animate-heading]')
    this.viewAll = this.el.querySelector('[data-animate-view-all]')
    this.callout = this.el.querySelector('[data-animate-callout]')
    this.events = this.el.querySelectorAll('[data-animate-event]')
    this.more = this.el.querySelectorAll('[ data-animate-more-links]')
    this.signupTrigger = this.el.querySelector('[data-show-signup]')
    this.closeTrigger = this.el.querySelector('[data-close-signup]')
    this.signupPanel = this.el.querySelector('[data-panel-signup]')
    this.eventsPanel = this.el.querySelector('[data-panel-events]')
    this.panel = this.el.querySelector('[data-panel-wrapper]')
    this.motion = lib.userMotionEnabled()
  }

  init() {
    this.signupTrigger.addEventListener('click', this.handleSignupClick)
    this.closeTrigger.addEventListener('click', this.handleSignupClose)
    // check to see if user has motion disabled
    if (this.motion) {
      this.handleScrollAnimation()
      if (this.callout) {
        gsap.set(this.callout, {
          autoAlpha: 0,
        })
      }
      gsap.set([this.heading, this.viewAll, this.events, this.more], {
        autoAlpha: 0,
      })
      gsap.set(this.signupPanel, {
        autoAlpha: 0,
      })
      this.signupPanel.classList.remove('hidden')
    }
  }

  handleSignupClose = (e) => {
    e.preventDefault()
    if (this.motion) {
      const tl = gsap.timeline()
      tl.to(this.signupPanel, {
        autoAlpha: 0,
        y: -10,
        duration: 0.15,
      })
    } else {
      this.signupPanel.classList.add('hidden')
    }
  }

  // handle click for sign up
  handleSignupClick = (e) => {
    e.preventDefault()
    const children = this.signupPanel.querySelectorAll('[data-animate]')
    if (this.motion) {
      gsap.set([this.signupPanel, children], { autoAlpha: 0, y: 30 })
      this.signupPanel.classList.remove('hidden')
      const tl = gsap.timeline()

      tl.to(this.signupPanel, {
        autoAlpha: 1,
        y: 0,
        duration: 0.1,
        ease: 'Back.easeInOut.config(1.7)',
      })
      tl.to(children, {
        autoAlpha: 1,
        y: 0,
        duration: 0.1,
        stagger: 0.05,
        ease: 'Back.easeInOut.config(1.7)',
      })
    } else {
      this.signupPanel.classList.remove('hidden')
    }
  }

  // initial animation tied to scrolling
  handleScrollAnimation() {
    const tlSequenceIn = gsap.timeline({
      ease: 'none',
      duration: 1,
      scrollTrigger: {
        trigger: this.el,
        start: 'top bottom',
        end: 'bottom bottom',
        scrub: 1,
        toggleActions: 'play none none reverse',
      },
    })

    tlSequenceIn.fromTo(
      [this.heading, this.viewAll],
      {
        autoAlpha: 0,
        y: 20,
      },
      {
        autoAlpha: 1,
        y: 0,
        stagger: 0.2,
      },
    )

    // callout doesn't always show
    if (this.callout) {
      tlSequenceIn.fromTo(
        [this.callout],
        {
          autoAlpha: 0,
          y: 40,
        },
        {
          autoAlpha: 1,
          y: 0,
        },
        '=-.2',
      )
    }

    if (this.events.length) {
      tlSequenceIn.fromTo(
        [this.events, this.more],
        {
          autoAlpha: 0,
          y: 40,
        },
        {
          autoAlpha: 1,
          y: 0,
          stagger: 0.15,
        },
        '=-.2',
      )
    }
  }
}
